import type { FaireProductEntity } from "../../entity_types/product";

export const p_2k57dc2xy4: FaireProductEntity = {
  token: "p_2k57dc2xy4",
  type: "product",
  name: "Eve Summer Sleeveless Dress- Hand Block printed - Open Back",
  brandToken: "b_3dexc9gstg",
  brandName: "Thuli",
  imageUrl:
    "https://cdn.faire.com/fastly/8754b309f905b4daa8348b1503a2575e5a8cc40c99f03fbd5af1d8769a3ea8b9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/50967a4d2b9f2c68c253626e699ee168eea032e86bc8b8dee535065f32b7ba08.jpeg",
    "https://cdn.faire.com/fastly/71a843ebd5dfcbc600a99824afd802f4e1793f7ed58fc6b8fe87655b9fb2e31a.jpeg",
    "https://cdn.faire.com/fastly/6caaf9dae22f199c512d34851b0119b4a95b6d67f5c359c25b9b7c23453d417c.jpeg",
    "https://cdn.faire.com/fastly/04d63f685c918c0de2131148f54234ffbdceb14108af51baf86c1500addfb08a.jpeg",
    "https://cdn.faire.com/fastly/f8fed07e61943caa6b41e7f3a94bb79acde0155d30db1bedcf5988f13186bd4f.jpeg",
  ],
  priceDollars: 102,
  description:
    "Crafted from soft handloom cotton, the Eve Dress boasts a stunning open back and gathered waist, all on a soft blue and white striped khadi fabric.\n\n• Blue\n• Hand-woven cotton\n• Khadi cotton\n• Sleeveless dress\n• Open back\n• Side pockets\n• Striped dress\n• Easy relaxed fit\n\nThis product has passed through a few beautiful hands to get to you!",
  tags: [],
  msrpDollars: 255,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:42.921Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
